import { computed, Injectable, signal } from '@angular/core';

export enum FieldInterventionMapModeEnum {
    DEFAULT = 'DEFAULT',
    CREATE_SELECTION = 'CREATE_SELECTION',
    FIELD_INTERVENTION_ENTITIES = 'FIELD_INTERVENTION_ENTITIES',
}

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionMapModeService {
    public readonly mode = signal<FieldInterventionMapModeEnum>(FieldInterventionMapModeEnum.DEFAULT);
    public readonly shouldShowFieldInterventionAreaMask = computed(() => {
        return (
            this.mode() === FieldInterventionMapModeEnum.CREATE_SELECTION ||
            this.mode() === FieldInterventionMapModeEnum.FIELD_INTERVENTION_ENTITIES
        );
    });

    public enterCreateSelectionMode(): void {
        this.mode.set(FieldInterventionMapModeEnum.CREATE_SELECTION);
    }

    public enterFieldInterventionEntitiesMode(): void {
        this.mode.set(FieldInterventionMapModeEnum.FIELD_INTERVENTION_ENTITIES);
    }

    public leaveFieldInterventionMapMode(): void {
        this.mode.set(FieldInterventionMapModeEnum.DEFAULT);
    }
}
